import { useNavigate } from 'react-router-dom';

const categories = ['Lab Reports', 'Imaging', 'Prescriptions', 'Advance Directives'];

export default function AllStorage({ uploadedDocuments }) {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/files/${encodeURIComponent(category)}`);
  };

  return (
    <section className="space-y-6">
      <h2 className="text-2xl font-semibold">Your Health Documents</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {categories.map((category) => (
          <button
            key={category}
            className="p-4 bg-white shadow rounded text-left"
            onClick={() => handleCategoryClick(category)}
          >
            <h3 className="text-lg font-semibold text-[#04395b]">{category}</h3>
            <p className="text-sm text-gray-600">
              {uploadedDocuments[category]?.length || 0} files
            </p>
          </button>
        ))}
      </div>

    </section>
  );
}